import { createContext, useContext, type ReactNode } from "react";
import type * as google_protobuf_timestamp_pb from "google-protobuf/google/protobuf/timestamp_pb";

import {
  type DisplayDateTimePolicy,
  formatTimestampWithPolicy,
  IOX_DATETIME_US_12H_POLICY,
} from "../branding/datetimeBranding";

const globalDisplayDateTimePolicy: DisplayDateTimePolicy = IOX_DATETIME_US_12H_POLICY;

const DisplayDateTimeContext = createContext<DisplayDateTimePolicy>(globalDisplayDateTimePolicy);

export function DisplayDateTimeProvider(props: { policy: DisplayDateTimePolicy; children: ReactNode }) {
  return (
    <DisplayDateTimeContext.Provider value={props.policy}>{props.children}</DisplayDateTimeContext.Provider>
  );
}

/** Network Server (global) layout: US 12-hour datetime format. */
export function GlobalDisplayDateTimeProvider(props: { children: ReactNode }) {
  return <DisplayDateTimeContext.Provider value={globalDisplayDateTimePolicy}>{props.children}</DisplayDateTimeContext.Provider>;
}

export function useDisplayDateTimePolicy(): DisplayDateTimePolicy {
  return useContext(DisplayDateTimeContext);
}

export function useFormatDisplayTimestamp(): (
  input: google_protobuf_timestamp_pb.Timestamp | Date | number | undefined,
) => string {
  const policy = useDisplayDateTimePolicy();
  return (input) => formatTimestampWithPolicy(input, policy);
}
